/**
 * Canonical insurer names and known aliases for GEO UI (logos, labels, filters).
 * Kept in the frontend — not sourced from clients.alias or MI backend.
 */

export const GEO_BRAND_ALIAS_ENTRIES = [
  {
    canonical: 'Mutual of Omaha Insurance Company',
    aliases: ['mutual of omaha insurance company', 'mutual of omaha', 'moo'],
    domain: 'mutualofomaha.com',
  },
  {
    canonical: 'Massachusetts Mutual Life Insurance Company',
    aliases: ['massachusetts mutual life insurance company', 'massachusetts mutual', 'massmutual'],
    domain: 'massmutual.com',
  },
  {
    canonical: 'Metropolitan Life Insurance Company',
    aliases: ['metropolitan life insurance company', 'metropolitan life', 'metlife'],
    domain: 'metlife.com',
  },
  {
    canonical: 'New York Life Insurance Company',
    aliases: ['new york life insurance company', 'new york life', 'ny life'],
    domain: 'newyorklife.com',
  },
  {
    canonical: 'The Northwestern Mutual Life Insurance Company',
    aliases: [
      'the northwestern mutual life insurance company',
      'northwestern mutual life insurance company',
      'northwestern mutual',
      'northwestern',
    ],
    domain: 'northwesternmutual.com',
  },
  {
    canonical: 'Transamerica Life Insurance Company',
    aliases: ['transamerica life insurance company', 'transamerica'],
    domain: 'transamerica.com',
  },
];

function normalizeKey(value) {
  return String(value || '').trim().toLowerCase();
}

export function resolveGeoBrandDomain(brandName) {
  const key = normalizeKey(brandName);
  if (!key) return null;

  for (const entry of GEO_BRAND_ALIAS_ENTRIES) {
    const keys = [normalizeKey(entry.canonical), ...entry.aliases.map(normalizeKey)];
    if (keys.some((alias) => key === alias || key.includes(alias) || alias.includes(key))) {
      return entry.domain;
    }
  }
  return null;
}

export function geoBrandNamesMatch(a, b) {
  const left = normalizeKey(a);
  const right = normalizeKey(b);
  if (!left || !right) return false;
  if (left === right || left.includes(right) || right.includes(left)) return true;

  for (const entry of GEO_BRAND_ALIAS_ENTRIES) {
    const keys = [normalizeKey(entry.canonical), ...entry.aliases.map(normalizeKey)];
    const leftHit = keys.some((k) => left === k || left.includes(k) || k.includes(left));
    const rightHit = keys.some((k) => right === k || right.includes(k) || k.includes(right));
    if (leftHit && rightHit) return true;
  }
  return false;
}

export function resolveGeoBrandLogoUrl(brandName, { size = 64 } = {}) {
  const domain = resolveGeoBrandDomain(brandName);
  if (!domain) return null;
  return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(domain)}&sz=${size}`;
}
